// skeleton/app/src/constants/appConstants.ts

export class ApiEndpoints {
  static readonly BASE_URL: string =
    import.meta.env.VITE_API_URL || "http://localhost:3000";

  static readonly GetAllProviders: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetAllProviders`;

  static readonly GetProviderDetails: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetAProviderInfo`;

  static readonly GetAllProviderFileInfo: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetAllProviderFileInfo`;

  static readonly DownloadErrorReport: string =
    `${ApiEndpoints.BASE_URL}/Provider/DownloadErrorReport`;

  static readonly DownloadProviderDataFile: string =
    `${ApiEndpoints.BASE_URL}/Provider/DownloadProviderDataFile`;

  static readonly GetExceptions: string =
    `${ApiEndpoints.BASE_URL}/Error/GetExceptions`;

  static readonly DownloadSupportingDataFile: string =
    `${ApiEndpoints.BASE_URL}/Provider/DownloadSupportingDataFile`;

  static readonly GetProviderFileZip: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetProviderFileZip`;

  static readonly GetAllPerformanceStandardsMeasuresInfo: string =
    `${ApiEndpoints.BASE_URL}/PerformanceEvaluation/GetAllPerformanceStandardsMeasuresInfo`;

  static readonly GetPBCReasons: string =
    `${ApiEndpoints.BASE_URL}/PerformanceEvaluation/GetReasons`;

  static readonly GetTiers: string =
    `${ApiEndpoints.BASE_URL}/Tier/GetTiers`;

  static readonly GetPagedTiers: string =
    `${ApiEndpoints.BASE_URL}/Tier/GetPagedTiers`;

  static readonly SubmitPerformanceEvaluation: string =
    `${ApiEndpoints.BASE_URL}/PerformanceEvaluation/CalculateTier`;

  static readonly SavePerformanceEvaluation: string =
    `${ApiEndpoints.BASE_URL}/PerformanceEvaluation/SavePerformanceEvaluation`;

  static readonly GetStatus: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GetStatus`;

  static readonly IsActiveReview: string =
    `${ApiEndpoints.BASE_URL}/ReviewCycle/IsReviewCycleActive`;

  static readonly SetReviewStatus: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/SetStatus`;

  static readonly MarkAsCompleted: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/MarkAsCompleted`;

  static readonly GetStatusesByRole: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GetStatusesByRole`;

  static readonly GetReviewReasons: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GetReviewReasons`;

  static readonly GeneratePBCDecisionLetter: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GenerateDecisionLetter`;

  static readonly GetMeasureEvaluationStatuses: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GetMeasureEvaluationStatuses`;

  static readonly BeginReviewCycle: string =
    `${ApiEndpoints.BASE_URL}/ReviewCycle/BeginReviewCycle`;

  static readonly EndReviewCycle: string =
    `${ApiEndpoints.BASE_URL}/ReviewCycle/EndReviewCycle`;

  static readonly ExtractDataByDataSource: string =
    `${ApiEndpoints.BASE_URL}/Provider/DownloadDataExtract`;

  static readonly GetAllPerformanceStandards: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetAllPerformanceStandards`;

  static readonly GetMeasureStatuses: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetMeasureStatuses`;

  static readonly GetMeasureStandardDetails: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetMeasureStandardDetails`;

  static readonly GetAllContractTimeframes: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetAllContractTimeframes`;

  static readonly GetQuestionDataForStandardAssociation: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetQuestionDataForStandardAssociation`;

  static readonly UpdateMeasureStandardDetails: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/UpdateMeasureStandardDetails`;

  static readonly GetAllComments: string =
    `${ApiEndpoints.BASE_URL}/Comment/GetCommentsForMeasure`;

  static readonly GetMeasureComments: string =
    `${ApiEndpoints.BASE_URL}/Comment/GetMeasureComments`;

  static readonly SaveComment: string =
    `${ApiEndpoints.BASE_URL}/Comment/AddComment`;

  static readonly DeleteComment: string =
    `${ApiEndpoints.BASE_URL}/Comment/DeleteComment`;

  static readonly GetAllCommentsForProvider: string =
    `${ApiEndpoints.BASE_URL}/Comment/GetAllCommentsForProvider`;

  static readonly GetCurrentReviewYearDetails: string =
    `${ApiEndpoints.BASE_URL}/ReviewConfig/GetCurrentReviewYearDetails`;

  static readonly GetAllActiveReviewYearDetails: string =
    `${ApiEndpoints.BASE_URL}/ReviewConfig/GetAllActiveReviewYearDetails`;

  static readonly GetAllReviewConfigurations: string =
    `${ApiEndpoints.BASE_URL}/ReviewConfig/GetAllReviewConfigurations`;

  static readonly AddReviewConfiguration: string =
    `${ApiEndpoints.BASE_URL}/ReviewConfig/AddReviewConfiguration`;

  static readonly UpdateReviewConfiguration: string =
    `${ApiEndpoints.BASE_URL}/ReviewConfig/UpdateReviewConfiguration`;

  static readonly DeleteReviewConfiguration: string =
    `${ApiEndpoints.BASE_URL}/ReviewConfig/DeleteReviewConfiguration`;

  static readonly GetFileMetadata: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetFileMetaInfoByName`;

  static readonly InitiateMultipartUpload: string =
    `${ApiEndpoints.BASE_URL}/Provider/InitiateMultipartUpload`;

  static readonly InitiateMultipartBulkUpload: string =
    `${ApiEndpoints.BASE_URL}/Provider/InitiateMultipartBulkUpload`;

  static readonly UploadMultipartFile: string =
    `${ApiEndpoints.BASE_URL}/Provider/UploadFileChunks`;

  static readonly CompleteMultipartUpload: string =
    `${ApiEndpoints.BASE_URL}/Provider/CompleteMultipartUpload`;

  static readonly AbortMultipartUpload: string =
    `${ApiEndpoints.BASE_URL}/Provider/AbortMultipartUpload`;

  static readonly ProcessFile: string =
    `${ApiEndpoints.BASE_URL}/Provider/Process`;

  static readonly ProcessZipFile: string =
    `${ApiEndpoints.BASE_URL}/Provider/ProcessZip`;

  static readonly fileProcessingHub: string =
    `${ApiEndpoints.BASE_URL}/fileProcessingHub`;

  static readonly getTableauAccessInfo: string =
    `${ApiEndpoints.BASE_URL}/Tableau/GetAccessInfo`;

  static readonly getAuthorizationToken: string =
    `${ApiEndpoints.BASE_URL}/User/GetAuthorizationToken`;

  static readonly Logout: string =
    `${ApiEndpoints.BASE_URL}/User/Logout`;

  static readonly UserLogout: string =
    `${ApiEndpoints.BASE_URL}/User/Logout`;

  static readonly SyncProviderStatusWithIntake: string =
    `${ApiEndpoints.BASE_URL}/SurveyIntake/SyncProviderStatusWithIntake`;

  static readonly SyncProviderReviewStatusWithIntake: string =
    `${ApiEndpoints.BASE_URL}/SurveyIntake/SyncProviderReviewStatusWithIntake`;

  static readonly getScoKpiDashboardData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetScoKpiDashboardData`;

  static readonly getScoProvidersData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetScoProvidersData`;

  static readonly getRsProvidersData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetRsProvidersData`;

  static readonly getDemoProvidersData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetDemoProvidersData`;

  static readonly getProvidersAdminData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetProvidersAdminData`;

  static readonly getScoProvidersAdminData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetScoProvidersAdminData`;

  static readonly getRsProvidersAdminData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetRsProvidersAdminData`;

  static readonly getRsKpiDashboardData: string =
    `${ApiEndpoints.BASE_URL}/Dashboard/GetRsKpiDashboardData`;

  static readonly GetProviderAdditionalInfo: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetProviderAdditionalInfo`;

  static readonly StartReview: string =
    `${ApiEndpoints.BASE_URL}/Reviewer/StartReview`;

  static readonly GetReviewersDetailsByMpi: string =
    `${ApiEndpoints.BASE_URL}/Reviewer/GetReviewersDetailsByMpi`;

  static readonly CanHaveAccessToReview: string =
    `${ApiEndpoints.BASE_URL}/Reviewer/CanHaveAccessToReview`;

  static readonly GetReviewActivityLogs: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GetReviewActivityLogs`;

  static readonly GetSupportingBulkUploadData: string =
    `${ApiEndpoints.BASE_URL}/DataUpload/GetSupportingBulkUploadData`;

  static readonly GetNoticeData: string =
    `${ApiEndpoints.BASE_URL}/DataUpload/GetNoticeData`;

  static readonly DownloadDecisionLetterFile: string =
    `${ApiEndpoints.BASE_URL}/DataUpload/DownloadDecisionLetterFile`;

  static readonly DownloadDisputeDecisionLetterFile: string =
    `${ApiEndpoints.BASE_URL}/DataUpload/DownloadDisputeDecisionLetterFile`;

  static readonly DownloadProviderZipFile: string =
    `${ApiEndpoints.BASE_URL}/DataUpload/DownloadProviderZipFile`;

  static readonly GetProviderTypes: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetProviderTypes`;

  static readonly GetDocumentTypeForProvider: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetDocumentTypeForProvider`;

  static readonly GetAllSmeUsers: string =
    `${ApiEndpoints.BASE_URL}/User/GetAllSmeUsers`;

  static readonly GetCompositeMeasureGroups: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetCompositeMeasureGroups`;

  static readonly SendEmail: string =
    `${ApiEndpoints.BASE_URL}/Email/SendEmail`;

  static readonly SendGeneralEmail: string =
    `${ApiEndpoints.BASE_URL}/Email/SendGeneralEmail`;

  static readonly GetMeasureScoringCriteria: string =
    `${ApiEndpoints.BASE_URL}/Measure/GetMeasureScoringCriteria`;

  static readonly GetProjectConfigurationDetailsByKey: string =
    `${ApiEndpoints.BASE_URL}/ProjectConfiguration/GetConfigByKey`;

  static readonly GetReviewOutcome: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetReviewOutcome`;

  static readonly GetAgencyContactDetails: string =
    `${ApiEndpoints.BASE_URL}/Provider/GetAgencyContactDetails`;

  static readonly GetProviderFeature: string =
    `${ApiEndpoints.BASE_URL}/Feature/GetProviderFeature`;

  static readonly AddUpdateProviderFeature: string =
    `${ApiEndpoints.BASE_URL}/Feature/AddUpdateProviderFeature`;

  static readonly GetAllEvents: string =
    `${ApiEndpoints.BASE_URL}/Event/GetAllEvents`;

  static readonly GetAllEventStatuses: string =
    `${ApiEndpoints.BASE_URL}/Event/GetAllEventStatuses`;

  static readonly ExeciteEvents: string =
    `${ApiEndpoints.BASE_URL}/DataExchange/ExecuteEvents`;

  static readonly getPfpScoKpiDashboardData: string =
    `${ApiEndpoints.BASE_URL}/PfpDashboard/GetPfpScoKpiDashboardData`;

  static readonly getPfpScoProvidersData: string =
    `${ApiEndpoints.BASE_URL}/PfpDashboard/GetPfpScoProvidersData`;

  static readonly GetPFPProviderDetails: string =
    `${ApiEndpoints.BASE_URL}/PfpProvider/GetPfpProviderInfo`;

  static readonly GetAllPfpPerformanceStandardsMeasuresInfo: string =
    `${ApiEndpoints.BASE_URL}/PfpPerformanceEvaluation/GetAllPfpPerformanceStandardsMeasuresInfo`;

  static readonly GetCalculatedIncentiveInfo: string =
    `${ApiEndpoints.BASE_URL}/Pfp/GetPfpIncentive`;

  static readonly GetIncentiveMappingInfo: string =
    `${ApiEndpoints.BASE_URL}/Pfp/GetPfpIncentiveMapping`;

  static readonly GetReasons: string =
    `${ApiEndpoints.BASE_URL}/PfpReview/GetPfpFailDecisionReasons`;

  static readonly SavePfpPerformanceEvaluation: string =
    `${ApiEndpoints.BASE_URL}/PfpPerformanceEvaluation/SavePfpPerformanceEvaluation`;

  static readonly GenerateDecisionLetter: string =
    `${ApiEndpoints.BASE_URL}/PfpReview/GenerateDecisionLetter`;

  static readonly SetPfpReviewStatus: string =
    `${ApiEndpoints.BASE_URL}/PfpReview/SetPfpStatus`;

  static readonly GetAllPfpComments: string =
    `${ApiEndpoints.BASE_URL}/PfpComment/GetPfpCommentsForMeasure`;

  static readonly SavePfpComment: string =
    `${ApiEndpoints.BASE_URL}/PfpComment/AddComment`;

  static readonly DeletePfpComment: string =
    `${ApiEndpoints.BASE_URL}/PfpComment/DeleteComment`;

  static readonly GetAllPfpCommentsForProvider: string =
    `${ApiEndpoints.BASE_URL}/PfpComment/GetAllCommentsForProvider`;

  static readonly getFailCommentsForMeasure: string =
    `${ApiEndpoints.BASE_URL}/PfpComment/GetFailCommentsForMeasure`;

  static readonly IsPfpActiveReview: string =
    `${ApiEndpoints.BASE_URL}/PfpReviewCycle/IsReviewCycleActive`;

  static readonly BeginPfpReviewCycle: string =
    `${ApiEndpoints.BASE_URL}/PfpReviewCycle/BeginReviewCycle`;

  static readonly EndPfpReviewCycle: string =
    `${ApiEndpoints.BASE_URL}/PfpReviewCycle/EndReviewCycle`;

  static readonly GetPfpReviewersDetailsByMpi: string =
    `${ApiEndpoints.BASE_URL}/PfpReviewer/GetReviewersDetailsByMpi`;

  static readonly PfpStartReview: string =
    `${ApiEndpoints.BASE_URL}/PfpReviewer/StartReview`;

  static readonly PfpCanHaveAccessToReview: string =
    `${ApiEndpoints.BASE_URL}/PfpReviewer/CanHaveAccessToReview`;

  static readonly GetPfpStatusesByRole: string =
    `${ApiEndpoints.BASE_URL}/PfpReview/GetStatusesByRole`;

  static readonly GetPfpMeasureEvaluationStatuses: string =
    `${ApiEndpoints.BASE_URL}/PfpReview/GetMeasureEvaluationStatuses`;

  static readonly GetScoringCriteria: string =
    `${ApiEndpoints.BASE_URL}/PfpPerformanceEvaluation/GetScoringCriteria`;

  static readonly GetPfpReviewStatus: string =
    `${ApiEndpoints.BASE_URL}/PfpReview/GetPfpStatus`;

  static readonly SyncCalculationData: string =
    `${ApiEndpoints.BASE_URL}/MeasureCalculation/SyncCalculatedMeasureDataToIntake`;

  static readonly BeginDisputeCycle: string =
    `${ApiEndpoints.BASE_URL}/DisputeCycle/BeginDisputeCycle`;

  static readonly EndDisputeCycle: string =
    `${ApiEndpoints.BASE_URL}/DisputeCycle/EndDisputeCycle`;

  static readonly IsActiveDisputeCycle: string =
    `${ApiEndpoints.BASE_URL}/DisputeCycle/IsDisputeCycleActive`;

  static readonly ChangeReviewStatusForDispute: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/ChangeReviewStatusForDispute`;

  static readonly GetAllPerformanceStandardsMeasuresDisputeInfo: string =
    `${ApiEndpoints.BASE_URL}/PerformanceEvaluation/GetAllPerformanceStandardsMeasuresDisputeInfo`;

  static readonly DownloadFileByRelativePath: string =
    `${ApiEndpoints.BASE_URL}/DataUpload/DownloadFileByRelativePath`;

  static readonly IsPfpActiveDisputeCycle: string =
    `${ApiEndpoints.BASE_URL}/PfpDisputeCycle/IsDisputeCycleActive`;

  static readonly BeginPfpDisputeCycle: string =
    `${ApiEndpoints.BASE_URL}/PfpDisputeCycle/BeginDisputeCycle`;

  static readonly EndPfpDisputeCycle: string =
    `${ApiEndpoints.BASE_URL}/PfpDisputeCycle/EndDisputeCycle`;

  static readonly ChangePfpReviewStatusForDispute: string =
    `${ApiEndpoints.BASE_URL}/PfpReview/ChangePfpReviewStatusForDispute`;

  static readonly GetAllPfpPerformanceStandardsMeasuresDisputeInfo: string =
    `${ApiEndpoints.BASE_URL}/PfpPerformanceEvaluation/GetAllPfpPerformanceStandardsMeasuresDisputeInfo`;

  static readonly initiateResourceMultipartUploadUrl: string =
    `${ApiEndpoints.BASE_URL}/Resource/InitiateMultipartUpload`;

  static readonly uploadResourceMultipart: string =
    `${ApiEndpoints.BASE_URL}/Resource/UploadFileChunks`;

  static readonly completeResourceMultipartUploadUrl: string =
    `${ApiEndpoints.BASE_URL}/Resource/CompleteMultipartUpload`;

  static readonly DownloadResourceByDocumentType: string =
    `${ApiEndpoints.BASE_URL}/Resource/DownloadResourceByDocumentType`;

  static readonly getResourceDocumentTypesUrl: string =
    `${ApiEndpoints.BASE_URL}/Resource/GetResourceDocumentTypes`;

  static readonly getCalculatedMeasures: string =
    `${ApiEndpoints.BASE_URL}/MeasureCalculation/GetCalculatedMeasures`;

  static readonly performCalculations: string =
    `${ApiEndpoints.BASE_URL}/MeasureCalculation/PerformMeasureCalculation`;

  static readonly pushCalculatedData: string =
    `${ApiEndpoints.BASE_URL}/MeasureCalculation/PushCalculatedData`;

  static readonly GetGraduatedMeasuresInfo: string =
    `${ApiEndpoints.BASE_URL}/GraduateMeasures/GetGraduatedMeasuresInfo`;

  static readonly saveGraduaateMeasureReview: string =
    `${ApiEndpoints.BASE_URL}/GraduateMeasures/SaveGraduatedReviewResponse`;

  static readonly GetGraduatedReviewInfo: string =
    `${ApiEndpoints.BASE_URL}/GraduateMeasures/GetGraduatedReviewDetais`;

  static readonly RemoveGraduateReviewsBySourceMeasure: string =
    `${ApiEndpoints.BASE_URL}/GraduateMeasures/RemoveGraduateReviewsBySourceMeasure`;

  static readonly SendEmailToMpis: string =
    `${ApiEndpoints.BASE_URL}/Email/SendEmailToMpis`;

  static readonly SyncMeasureDetailsToIntake: string =
    `${ApiEndpoints.BASE_URL}/Measure/SyncMeasureDetailsToIntake`;

  static readonly GetAllStandards: string =
    `${ApiEndpoints.BASE_URL}/Standard/GetAllStandards`;

  static readonly GetPagedStandards: string =
    `${ApiEndpoints.BASE_URL}/Standard/GetPagedStandards`;

  static readonly GetTiersWithInactive: string =
    `${ApiEndpoints.BASE_URL}/Tier/GetTiersWithInactive`;

  static readonly DeleteTier: string =
    `${ApiEndpoints.BASE_URL}/Tier/DeleteTier`;

  static readonly BulkUploadTiers: string =
    `${ApiEndpoints.BASE_URL}/Tier/BulkUploadTiers`;

  static readonly UpdateTier: string =
    `${ApiEndpoints.BASE_URL}/Tier/UpdateTier`;

  static readonly AddTier: string =
    `${ApiEndpoints.BASE_URL}/Tier/AddTier`;

  static readonly AddMeasure: string =
    `${ApiEndpoints.BASE_URL}/Measure/CreateMeasure`;

  static readonly UpdateMeasure: string =
    `${ApiEndpoints.BASE_URL}/Measure/UpdateMeasure`;

  static readonly DeleteMeasure: string =
    `${ApiEndpoints.BASE_URL}/Measure/DeleteMeasure`;

  static readonly GetAllMeasures: string =
    `${ApiEndpoints.BASE_URL}/Measure/GetAllMeasures`;

  static readonly GetPagedMeasures: string =
    `${ApiEndpoints.BASE_URL}/Measure/GetPagedMeasures`;

  static readonly BulkUploadMeasures: string =
    `${ApiEndpoints.BASE_URL}/Measure/BulkUploadMeasures`;

  static readonly GetAllMeasuresWithInactive: string =
    `${ApiEndpoints.BASE_URL}/Measure/GetAllMeasuresWithInactive`;

  static readonly GetAllPerformanceAreasWithInactive: string =
    `${ApiEndpoints.BASE_URL}/PreformanceArea/GetAllPerformanceAreasWithInactive`;

  static readonly GetAllPerformanceAreas: string =
    `${ApiEndpoints.BASE_URL}/PreformanceArea/GetAllPerformanceAreas`;

  static readonly GetPagedPerformanceAreas: string =
    `${ApiEndpoints.BASE_URL}/PreformanceArea/GetPagedPerformanceAreas`;

  static readonly AddPerformanceArea: string =
    `${ApiEndpoints.BASE_URL}/PreformanceArea/CreatePerformanceArea`;

  static readonly UpdatePerformanceArea: string =
    `${ApiEndpoints.BASE_URL}/PreformanceArea/UpdatePerformanceArea`;

  static readonly DeletePerformanceArea: string =
    `${ApiEndpoints.BASE_URL}/PreformanceArea/DeletePerformanceArea`;

  static readonly BulkUploadPerformanceAreas: string =
    `${ApiEndpoints.BASE_URL}/PreformanceArea/BulkUploadPerformanceAreas`;

  static readonly AddStandard: string =
    `${ApiEndpoints.BASE_URL}/Standard/CreateStandard`;

  static readonly UpdateStandard: string =
    `${ApiEndpoints.BASE_URL}/Standard/UpdateStandard`;

  static readonly DeleteStandard: string =
    `${ApiEndpoints.BASE_URL}/Standard/DeleteStandard`;

  static readonly BulkUploadStandards: string =
    `${ApiEndpoints.BASE_URL}/Standard/BulkUploadStandards`;

  static readonly GetAllPerformanceStandardsWithInactive: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetAllPerformanceStandardsWithInactive`;

  static readonly GetAllPerformanceStandardsActive: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetAllPerformanceStandardsActive`;

  static readonly GetPagedPerformanceStandardsActive: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/GetPagedPerformanceStandardsActive`;

  static readonly AddPerformanceStandard: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/CreatePerformanceStandard`;

  static readonly UpdatePerformanceStandard: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/UpdatePerformanceStandard`;

  static readonly DeletePerformanceStandard: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/DeletePerformanceStandard`;

  static readonly BulkUploadPerformanceStandards: string =
    `${ApiEndpoints.BASE_URL}/PerformanceStandard/BulkUploadPerformanceStandards`;

  static readonly GetAllReviewStatus: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GetAllReviewStatus`;

  static readonly GetPagedReviewStatuses: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/GetPagedReviewStatuses`;

  static readonly AddReviewStatus: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/AddReviewStatus`;

  static readonly UpdateReviewStatus: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/UpdateReviewStatus`;

  static readonly DeleteReviewStatus: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/DeleteReviewStatus`;

  static readonly BulkUploadReviewStatuses: string =
    `${ApiEndpoints.BASE_URL}/ReviewStatus/BulkUploadReviewStatuses`;

  static readonly GetAllQuestions: string =
    `${ApiEndpoints.BASE_URL}/Question/GetQuestions`;

  static readonly GetPagedQuestions: string =
    `${ApiEndpoints.BASE_URL}/Question/GetPagedQuestions`;

  static readonly GetQuestionTypes: string =
    `${ApiEndpoints.BASE_URL}/Question/GetQuestionTypes`;

  static readonly AddQuestion: string =
    `${ApiEndpoints.BASE_URL}/Question/AddQuestion`;

  static readonly UpdateQuestion: string =
    `${ApiEndpoints.BASE_URL}/Question/UpdateQuestion`;

  static readonly DeleteQuestion: string =
    `${ApiEndpoints.BASE_URL}/Question/DeleteQuestion`;

  static readonly BulkUploadQuestions: string =
    `${ApiEndpoints.BASE_URL}/Question/BulkUploadQuestions`;

  static readonly BulkUploadDataManagement: string =
    `${ApiEndpoints.BASE_URL}/DataManagement/BulkUpload`;
}

export const ImportTemplates = {
  reviewConfigurations: "/templates/review-configurations-import-template.xlsx",
  tiers: "/templates/tiers-template.xlsx",
  measures: "/templates/measures-template.xlsx",
  standards: "/templates/standards-template.xlsx",
  performanceAreas: "/templates/performance-areas-template.xlsx",
  standardMeasureAssociation:
    "/templates/standard-measure-association-template.xlsx",
  reviewStatuses: "/templates/review-statuses-template.xlsx",
  questions: "/templates/questions-template.xlsx",
} as const;

export const DataFieldTypeOptions = [
  "textarea",
  "table with checkbox",
  "table dynamic",
  "table",
  "string (text)",
  "string ( number)",
  "string",
  "radio button",
  "internal",
  "dropdown",
  "document",
  "checkbox",
  "calculated measure",
] as const;

export class Constants {
  static readonly FILE_UPLOAD_SIZE_LIMIT: number = 209715200;

  static readonly ADMIN_GROUP_NAME: string = "idd-admin";
  static readonly SUPER_ADMIN_GROUP_NAME: string = "super-admin";
  static readonly FINAL_REVIEWER_GROUP_NAME: string = "final-reviewer";
  static readonly SME_REVIEWER_GROUP_NAME: string = "sme-reviewer";
  static readonly INITIAL_REVIEWER_GROUP_NAME: string = "initial-reviewer";

  static readonly ADMIN_NAME: string = "Admin";
  static readonly SUPER_ADMIN_NAME: string = "Super Admin";
  static readonly FINAL_REVIEWER_NAME: string = "Final Reviewer";
  static readonly SME_REVIEWER_NAME: string = "SME Reviewer";
  static readonly INITIAL_REVIEWER_NAME: string = "Initial Reviewer";

  static readonly FILE_NOT_FOUND_ERROR: string =
    "The document you're trying to download is currently unavailable. Please check back later or contact support if you need further assistance.";

  static readonly KPI_IS_ENABLED: boolean =
    String(import.meta.env.VITE_KPI_IS_ENABLED).toLowerCase() === "true";

  static readonly INACTIVITY_SESSION_TIMEOUT: number =
    Number(import.meta.env.VITE_INACTIVITY_SESSION_TIMEOUT);

  static readonly TABLEAU_EXECUTIVE_DASHBOARD_NAME: string =
    "EXECUTIVE_DASHBOARD";

  static readonly TABLEAU_PROVIDER_DETAILS_DASHBOARD_NAME: string =
    "PROVIDER_DETAILS_DASHBOARD";

  static readonly TABLEAU_QUALITY_CONTROL_DASHBOARD_NAME: string =
    "QUALITY_CONTROL_DASHBOARD";

  static readonly TABLEAU_P4P_DASHBOARD_NAME: string =
    "P4P_DASHBOARD";

  static readonly IS_REALTIME_REVIEW_STATUS_SYNC_ENABLED: boolean =
    String(
      import.meta.env.VITE_IS_REALTIME_REVIEW_STATUS_SYNC_ENABLED
    ).toLowerCase() === "true";

  static readonly IS_REALTIME_PROVIDER_TYPE_SYNC_ENABLED: boolean =
    String(
      import.meta.env.VITE_IS_REALTIME_PROVIDER_TYPE_SYNC_ENABLED
    ).toLowerCase() === "true";

  static readonly IS_SCO_PROVIDER: boolean =
    import.meta.env.VITE_PROVIDER_TYPE?.toUpperCase() === "RH";

  static readonly SCOKey: string = "SCO";
  static readonly RSKey: string = "RS";

  static readonly CredentialingTypeId: number = 1;
  static readonly TechnologyTypeId: number = 2;

  static readonly P4P_TABLEAU_URL_KEY: string =
    "P4P_TABLEAU_URL";

  static readonly PBC_TABLEAU_URL_KEY: string =
    "PBC_TABLEAU_URL";

  static readonly PBC_RS_TABLEAU_URL_KEY: string =
    "PBC_RS_TABLEAU_URL";

  static readonly TABLEAU_CDN_JS_URL_KEY: string =
    "TABLEAU_CDN_JS_URL";

  static readonly ExcludedTiers: string[] = [
    "UNASSIGNED",
    "NOT ELIGIBLE",
    "CONDITIONAL",
  ];

  static readonly MEASURE_LIBRARY_LOCKED: string =
    "MEASURE_LIBRARY_LOCKED";

  static readonly DATA_UPLOAD_CENTER_LOCKED: string =
    "DATA_UPLOAD_CENTER_LOCKED";

  static readonly CYPRESS_USER_NAME: string =
    import.meta.env.VITE_CYPRESS_USER_NAME || "";

  static readonly CYPRESS_PWD: string =
    import.meta.env.VITE_CYPRESS_PWD || "";

  static readonly UPLOAD_TYPE_RESOURCE: string =
    "Resource";

  static readonly DATA_MANAGEMENT_MODULES = {
    REVIEW_CONFIGURATIONS: "ReviewConfigurations",
    TIERS: "Tiers",
    MEASURES: "Measures",
    PERFORMANCE_AREAS: "PerformanceAreas",
    STANDARDS: "Standards",
    PERFORMANCE_STANDARDS: "PerformanceStandards",
    REVIEW_STATUSES: "ReviewStatuses",
    QUESTIONS: "Questions",
  } as const;
}